/**
 * Bot / virtual user flag schemas.
 *
 * Admin-only toggle: mark users as bot/virtual accounts for filtering
 * and analytics exclusion.
 */
import { z } from 'zod';

/** PATCH /api/admin/bot-flags/:id — toggle bot flag on a user. */
export const BotFlagPatchSchema = z.object({
  is_bot: z.boolean(),
  bot_note: z.string().max(255).optional(),
});
export type BotFlagPatchRequest = z.infer<typeof BotFlagPatchSchema>;

/** GET /api/admin/bot-flags — list bot-flagged users. */
export const BotFlagListQuerySchema = z.object({
  page: z.coerce.number().int().positive().default(1),
  limit: z.coerce.number().int().positive().max(200).default(50),
  is_bot: z
    .union([z.boolean(), z.string()])
    .optional()
    .transform((v) => {
      if (v === undefined || v === '') return undefined;
      if (typeof v === 'boolean') return v;
      return v === 'true';
    }),
});
export type BotFlagListQuery = z.infer<typeof BotFlagListQuerySchema>;
